import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import PersonIcon from 'material-design-icons/action/svg/production/ic_perm_identity_48px.svg';

import LoginForm from '../../components/LoginForm';
import SheetTitle from '../../components/SheetTitle';
import { smoothScroll } from '../../helpers/view';

import c from './Login.less';

class LoginContainer extends Component {
  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    smoothScroll();
  }

  render() {
    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Login at Mp3Caprice</title>
          <meta property="mc:dp" content="/shop/login" />
          <meta property="mc:page" content="Login" />
        </Helmet>
        <SheetTitle title="Log in" />
        <div className={c.wrapper}>
          <LoginForm />
        </div>
        <div className={c.personIcon}><PersonIcon /></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.user.loggedIn,
});

export default withRouter(connect(mapStateToProps)(LoginContainer));
